import { Directive, Host } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

@Directive({
  selector: '[stepperDisableLastStep]',
  standalone: false,
})
export class StepperDisableLastStep {
  constructor(@Host() private stepper: MatStepper) {
    this.overrideStepperNavigation();
  }

  private overrideStepperNavigation() {
    const canNavigateToLastStep = () => {
      return this.stepper.steps
        .toArray()
        .slice(0, -1)
        .every((step) => step.completed);
    };

    this.stepper['_anyControlsInvalidOrPending'] = (index: number) => {
      return index === 4 ? !canNavigateToLastStep() : false;
    };

    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(this.stepper), 'selectedIndex');
    if (descriptor?.set) {
      Object.defineProperty(this.stepper, 'selectedIndex', {
        get: descriptor.get,
        set: (value: number) => {
          if (value !== 4 || canNavigateToLastStep()) {
            descriptor.set!.call(this.stepper, value);
          }
        },
        configurable: true,
      });
    }
  }
}
